export default "__VITE_ASSET__DXIwICaJ__"